import { render, staticRenderFns } from "./FileInlineLink.vue?vue&type=template&id=382c0f98&"
import script from "./FileInlineLink.vue?vue&type=script&lang=js&"
export * from "./FileInlineLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports